let accessToken = null;

export const tokenStore = {
  get: () => {
    // Check memory first, then localStorage
    if (accessToken) return accessToken;
    try {
      const stored = localStorage.getItem('access_token');
      if (stored) {
        accessToken = stored;
        return stored;
      }
    } catch (e) {
      // localStorage not available (e.g., in private mode)
    }
    return null;
  },
  set: (t) => {
    accessToken = t;
    try {
      if (t) localStorage.setItem('access_token', t);
      else localStorage.removeItem('access_token');
    } catch (e) {
      // localStorage not available
    }
  },
  clear: () => {
    accessToken = null;
    try {
      localStorage.removeItem('access_token');
    } catch (e) {
      // localStorage not available
    }
  },
};
